module.exports = __webpack_public_path__ + "static/media/heroBack6.08e3acb5.svg";